export default "skymp5-front/2217324cbcf6c27a5a272e6b48606682.mp3";